import Vue from "vue";
import axios from "axios";
import store from '@/store'
import config from '@core/config/app.config.js'
import { refreshToken,toReauth } from "@core/config/utils";

export const http = axios.create({
  baseURL: config.SERVICE_API_BASE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  withCredentials: false,
});

http.interceptors.request.use(async (config) => {
  const keycloak = Vue.prototype.$keycloak;
  await refreshToken();
  config.headers["Authorization"] = 'Bearer ' + keycloak.token;
  config.headers["MP_ID_TOKEN"] = 'Bearer ' + keycloak.token;
  config.headers["TZ"] = store.state.auth.preferences.time_zone ? store.state.auth.preferences.time_zone : 'America/New_York'
  config.headers["Timezone"] = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return config;
});

// inject("$http", $http);
http.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response || error.request) {
      const data = error.response || error.request;
      switch (data.status) {
        case 500:
          store.commit("ui/snackbar", {
            title: "Error",
            message: "Something went wrong. Please try again",
            type: "error",
          });
          break;

        case 403:
          store.commit("ui/snackbar", {
            title: "Error",
            message: `${error.response.data.authorization[0]}`,
            type: "error",
          });
          break;

        case 401:
          store.dispatch("auth/logout", false);
          toReauth();
          break;

        default:
          return Promise.reject(error);
      }
    }
  }
);
export default http;
